/**
 * Remove product condition suffix (-SDT, -RFB, -DEF) from SKU/EAN for display.
 * Does not affect the underlying data.
 */
export function stripSkuSuffix(value: string | null | undefined): string {
  if (!value) return '';
  return value.replace(/-(SDT|RFB|DEF)$/, '');
}
